/**
 * NOTE:
 *
 * This file is automatically generated by i18n-tools.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
// Russian
export default {
    'fabric.atlassianSwitcher.switchTo': 'Переключиться на',
    'fabric.atlassianSwitcher.switchToTooltip': 'Переключиться на...',
    'fabric.atlassianSwitcher.recent': 'Недавние',
    'fabric.atlassianSwitcher.more': 'Еще',
    'fabric.atlassianSwitcher.try': 'Новинка',
    'fabric.atlassianSwitcher.manageList': 'Изменить список',
    'fabric.atlassianSwitcher.jiraProject': 'Проект Jira',
    'fabric.atlassianSwitcher.confluenceSpace': 'Раздел Confluence',
    'fabric.atlassianSwitcher.people': 'Люди',
    'fabric.atlassianSwitcher.administration': 'Администрирование',
    'fabric.atlassianSwitcher.discoverMore': 'Другие продукты',
    'fabric.atlassianSwitcher.errorHeading': 'Произошла ошибка',
    'fabric.atlassianSwitcher.errorText': 'Мы стараемся отслеживать все ошибки. Если обновление страницы не поможет, обязательно сообщите нам об этом.',
    'fabric.atlassianSwitcher.errorImageAltText': 'Несколько людей и один робот уже всё чинят.',
    'fabric.atlassianSwitcher.expand': 'Открыть',
};
//# sourceMappingURL=ru.js.map